import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link} from '@customink/pigment-react';

const propTypes = {
  dismiss: PropTypes.func,
  dismissed: PropTypes.bool,
  isAnyStyleLoaded: PropTypes.bool,
  notification: PropTypes.shape({
    error: PropTypes.shape({
      response: PropTypes.shape({
        status: PropTypes.number
      })
    })
  }),
  reset: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class StyleLoadErrorNotification extends Component {
  static displayName = 'StyleLoadErrorNotification';
  static propTypes = propTypes;

  state = {
    recoverable: true
  };

  UNSAFE_componentWillMount() {
    this.setRecoverability();
    if (!this.props.isAnyStyleLoaded) {
      this.props.reset();
    }
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.state.recoverable && this.props.dismissed !== nextProps.dismissed
    );
  }

  getStyleResponseStatus() {
    const {notification} = this.props;
    const {status} =
      (notification && notification.error && notification.error.response) || {};
    return status;
  }

  setRecoverability() {
    this.setState({
      recoverable:
        this.props.isAnyStyleLoaded || this.getStyleResponseStatus() < 500
    });
  }

  handleDismissAndReset = () => {
    this.props.reset();
    this.props.dismiss();
  };

  render() {
    const {dismiss, isAnyStyleLoaded} = this.props;
    if (isAnyStyleLoaded) {
      return (
        <Notification
          {...this.props}
          title={
            <span>
              Oops! Couldn’t load <span>your product.</span>
            </span>
          }>
          <p className="ndx-cta1">
            Try selecting your product again, or choose another product.
          </p>
          <Button
            size="large"
            variant="secondary"
            className="notification-cta"
            onClick={dismiss}>
            Close
          </Button>
        </Notification>
      );
    } else if (this.getStyleResponseStatus() < 500) {
      return (
        <Notification {...this.props} title="Couldn’t find your product">
          <p className="ndx-cta1">
            Sorry, looks like your product is either unavailable or
            discontinued.
          </p>
          <Button
            size="large"
            variant="secondary"
            className="notification-cta"
            href="#/productCatalog"
            onClick={this.handleDismissAndReset}>
            Try Another Product
          </Button>
        </Notification>
      );
    } else {
      return (
        <Notification
          {...this.props}
          dismiss={null}
          title={
            <span>
              Oops! Something <span>went wrong.</span>
            </span>
          }>
          <p className="ndx-cta1">
            Sorry, we’re having issues loading the <span>Design Lab</span>. Try
            refreshing your browser.
          </p>
          <p className="ndx-cta1">
            If the problem continues,{' '}
            <Link href="/contact" rel="noopener noreferrer" target="_blank">
              contact us
            </Link>
            .
          </p>
        </Notification>
      );
    }
  }
}

import {createStructuredSelector} from 'reselect';
import {isAnyStyleLoaded} from '~/selectors/ProductSelectors';

function select() {
  return createStructuredSelector({
    isAnyStyleLoaded
  });
}

import {bindActionCreators} from 'redux';
import {reset} from '~/actions/ProductActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      reset
    },
    dispatch
  );
}

import {connect} from 'react-redux';

export default connect(select, actions)(StyleLoadErrorNotification);
